import { getDevicrType, getDevcie, postDevcie, putDevice, deleteDevice } from '../../../api/eastCoastDataApi/deviceApi'
import Utils from '../../../utils/utils'

const state = {
  allDevice: [],
  deviceData: {},
  deviceTypes: []
}

const getters = {
  getDeviceType: state => {
    return state.deviceTypes
  },

  getDeviceData: state => {
    return state.deviceData
  },

  getAllDevice: state => {
    return state.allDevice
  },
}

const actions = {
  async getDevcieType({ commit }) {
    commit('deviceTypes', await getDevicrType())
  },

  async getDevice({ commit }, condition) {
    commit('deviceData', await getDevcie(condition))
  },

  async postDevice({ commit }, device) {
    const result = await postDevcie(device)
    if (result.success) {
      commit('updateDevice', { data: device, mode: 'post' })
    }

    return result
  },

  async putDevice({ commit }, device) {
    const result = await putDevice(device)
    if (result.success) {
      commit('updateDevice', { data: device, mode: 'put' })
    }

    return result
  },

  async deleteDevice({ commit }, deviceId) {
    const result = await deleteDevice(deviceId)
    if (result.success) {
      commit('updateDevice', { data: deviceId, mode: 'delete' })
    }

    return result
  }
}

const mutations = {
  deviceTypes(state, data) {
    if (Utils.isEmptyObject(data)) {
      return
    }

    state.deviceTypes = data
  },

  deviceData(state, data) {
    if (Utils.isEmptyObject(data) || Utils.isEmptyObject(data.deviceData)) {
      return
    }

    if (Utils.isEmptyString(data.deviceType)) {
      state.allDevice = data.deviceData
      state.deviceData = data.deviceData
    } else {
      state.deviceData[data.deviceType] = data.deviceData
    }
  },

  updateDevice(state, { data, mode }) {
    switch (mode) {
      case 'post':
        state.allDevice.push(data)
        break
      
      case 'put':
        let targetIndex  = state.allDevice.findIndex(d => d.id === data.id)
        if (targetIndex !== -1) {
          state.allDevice[targetIndex] = data;
        } 
        break
  
      case 'delete' :
        state.allDevice = state.allDevice.filter(d => d.id !== data)
        break    
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}